import { useEffect, useState } from "preact/hooks";

/** Renders a QR code as inline SVG (lazy-loads the encoder). */
export function QrCode({ value, size = 240, label }: { value: string; size?: number; label: string }) {
  const [svg, setSvg] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    import("qrcode")
      .then((m) => m.toString(value, { type: "svg", errorCorrectionLevel: "M", margin: 2, width: size }))
      .then((s) => {
        if (!cancelled) setSvg(s);
      })
      .catch(() => setSvg(null));
    return () => {
      cancelled = true;
    };
  }, [value, size]);
  if (!svg)
    return (
      <div style={{ width: size, height: size, background: "#fff", borderRadius: 16 }} aria-hidden="true" />
    );
  return (
    <div
      role="img"
      aria-label={label}
      style={{ width: size, height: size, background: "#fff", borderRadius: 16, padding: 8, display: "grid" }}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
